<template lang="html">
  <section v-if="store">
    <div class="container">
      <section class="hero is-small has-bg-img" :style="themableStyle">
        <!-- Hero body -->
        <div class="hero-body">
          <div class="columns">
            <div class="column">
              <div class="columns is-vcentered">
                <div class="column is-narrow">
                  <b-icon size="is-large" icon="cart" />
                </div>
                <div class="column">
                  <div class="columns">
                    <div class="column">
                      <h1 class="title">{{ store.name }}</h1>
                      <h2 class="subtitle is-size-5">@{{ store.nickname }}<br /></h2>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <div class="section">
        <div class="columns is-centered is-marginless pt-4">
          <div class="column is-10 is-paddingless">
            <h6 class="has-text-weight-semibold is-size-6">
              Crafts mentionning this shop
            </h6>
          </div>
        </div>
        <carousel-horizontal :images="images" />
        <div class="columns is-centered is-marginless pt-4">
          <div class="column is-10 is-paddingless">
            <h6 class="has-text-weight-semibold is-size-6">
              Purchases mentionning this shop
            </h6>
          </div>
        </div>
        <carousel-horizontal :images="images" />
        <div
          class="columns has-text-gray has-text-centered is-centered is-marginless pt-4"
        >
          <div class="column is-10 is-paddingless">
            <h6 class="is-italic is-size-6">
              You are the owner of
              <b class="has-text-dark-orange">{{ store.name }}</b> and would like more
              information on improving your visibility on our website? Please visit our
              section
              <router-link :to="{ path: `/sponsors` }">Sponsors</router-link>
            </h6>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import * as moment from 'moment'
import _ from 'lodash'
import CarouselHorizontal from '@/components/concerns/Images/CarouselHorizontal'

import { themableMixin } from '@/mixins/themableMixin'
export default {
  mixins: [themableMixin],
  data () {
    return {
      store: null,
      reviews: [],
      images: [
        {
          id: '65',
          type: 'image',
          attributes: {
            id: 65,
            caption: 'Dress Jewel by <a >Aetheya</a>, using Black Worbla',
            content: {
              url:
                'https://costuto-public.s3.eu-central-1.amazonaws.com/images/colors/primary2_hero.png'
            }
          }
        },
        {
          id: '68',
          type: 'image',
          attributes: {
            id: 68,
            caption: '',
            content: {
              url:
                'https://costuto-public.s3.eu-central-1.amazonaws.com/images/colors/primary2_hero.png'
            }
          }
        },
        {
          id: '67',
          type: 'image',
          attributes: {
            id: 67,
            caption: '',
            content: {
              url:
                'https://costuto-public.s3.eu-central-1.amazonaws.com/images/colors/primary2_hero.png'
            }
          }
        },
        {
          id: '66',
          type: 'image',
          attributes: {
            id: 66,
            caption: '',
            content: {
              url:
                'https://costuto-public.s3.eu-central-1.amazonaws.com/images/colors/primary2_hero.png'
            }
          }
        },
        {
          id: '69',
          type: 'image',
          attributes: {
            id: 69,
            caption: '',
            content: {
              url:
                'https://costuto-public.s3.eu-central-1.amazonaws.com/images/colors/primary2_hero.png'
            }
          }
        },
        {
          id: '70',
          type: 'image',
          attributes: {
            id: 70,
            caption: '',
            content: {
              url:
                'https://costuto-public.s3.eu-central-1.amazonaws.com/images/colors/primary2_hero.png'
            }
          }
        },
        {
          id: '71',
          type: 'image',
          attributes: {
            id: 71,
            caption: '',
            content: {
              url:
                'https://costuto-public.s3.eu-central-1.amazonaws.com/images/colors/primary2_hero.png'
            }
          }
        }
      ]
    }
  },
  components: { CarouselHorizontal },
  created () {
    this.fetchData()
  },
  computed: {
    storeScore () {
      let groupedScores = _.groupBy(this.reviews, (elem) => {
        return elem.attributes.user_id
      })
      let ponderedScores = Object.values(groupedScores).map((arr) => {
        return (
          _.reduceRight(
            arr,
            function (acc, element) {
              return acc + element.attributes.score
            },
            0
          ) / arr.length
        )
      })
      return (
        _.reduceRight(
          ponderedScores,
          function (ponderedScores, element) {
            return ponderedScores + element
          },
          0
        ) / ponderedScores.length
      )
    }
  },
  watch: {
    $route: 'fetchData'
  },
  methods: {
    fetchData () {
      this.$store
        .dispatch('stores/show', this.$route.params.store)
        .then((resp) => {
          this.store = resp.data.data.attributes
          this.$store
            .dispatch('stores/reviews/index', this.store.id)
            .then((resp) => {
              this.reviews = resp.data.data
            })
            .catch((_) => {
              // TODO: Handle error
              console.log('Error')
            })
        })
        .catch((error) => {
          // TODO: Handle error
          console.log(error.response.status)
        })
    },
    dateToYear (date) {
      return moment(date).locale(this.$i18n.locale).format('YYYY')
    }
  }
}
</script>

<style lang="scss" scoped>
.has-bg-img {
  background: linear-gradient(
      to right,
      rgba(255, 255, 255, 1),
      rgba(255, 255, 255, 0.7),
      rgba(255, 255, 255, 0.4),
      rgba(255, 255, 255, 0.2),
      rgba(255, 255, 255, 0.2),
      rgba(255, 255, 255, 0.4),
      rgba(255, 255, 255, 0.7),
      rgba(255, 255, 255, 1)
    ),
    url("https://costuto-public.s3.eu-central-1.amazonaws.com/images/colors/secondary_hero.png")
      no-repeat center center fixed;

  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
}
</style>
